import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'commercial_servicetype'

  static get fields () {
    return {
      id: new UUID(),
      uuid: new STRING(),
      name: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_a: new DATETIME()
    }
  }
}
